import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chip, Box, Button, Card, CardContent, Container, Fab, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { DataGrid } from '@mui/x-data-grid';
import { getqualitymaterialcode, getqualityinspection, getpitinventorydetails, fetchinspectordetails, fetchequipmentdetailsdetails, saveinspectiondetails, searchbyURN } from './qualityApi';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from "moment";
import { toast } from 'react-toastify';
import { capitalizeFunction, openTextFieldMaxLength, VALIDATION } from '../../common/commonValidations';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import { SearchIcon, SubmitIcon } from '../../common/icons';

function CreateNewInspectionOrder({ }) {
    const navigate = useNavigate();
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const [allmaterialcode, setAllMaterialCode] = useState([]);
    const [allinspectiondetails, setAllInspectionDetails] = useState([]);
    const [pitInventoryDetails, setPitInventoryDetails] = useState();
    const [getUrnList, setGetUrnList] = useState([]);
    const [createWorkOrderReqst, setCreateWorkOrderReqst] = useState([]);
    const [bundleIdEntity, setBundleIdEntity] = useState([]);
    const [search, setSearch] = useState(false);
    const [showtable, setShowTable] = useState(false);
    const [showURNInput, setShowURNInput] = useState(false);
    const [datevalue, setDateValue] = useState();
    const [inspectorDetails, setInspectorDetails] = useState([]);
    const [multiselectEquipment, setMultiSelectEquipment] = useState([]);
    const [allequipmentdetails, setAllEquipmentDetails] = useState([]);
    const [finalinspectionsubmission, setFinalInspectionSubmission] = useState();
    const [selectedLleIsData, setSelectedLleIsData] = React.useState([]);
    const [submit, setSubmit] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        errmaterialCode: '',
        errinspectionFor: '',
        errSelectedUrn: '',
        errSurprise: '',
        errequipmentused: '',
        errdescription: ''
    });
    const [details, setDetails] = useState({
        materialCode: '',
        inspectionFor: '',
        inspectDescription: '',
        inspectorName: '',
        inspectorEmail: '',
        inspectorMobileNo: '',
        selectedURN: ''
    });
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);

    useEffect(() => {
        getqualitymaterialcode(setAllMaterialCode);
        getqualityinspection(setAllInspectionDetails);
        fetchinspectordetails(setInspectorDetails);
        fetchequipmentdetailsdetails(setAllEquipmentDetails)
    }, []);
    useEffect(() => {
        if (details?.materialCode && details?.inspectionFor) {
            searchbyURN(details?.inspectionFor, details?.materialCode, setGetUrnList)
        }
    }, [details?.materialCode, details?.inspectionFor]);
    useEffect(() => {
        if (pitInventoryDetails) {
            setShowTable(true)
            const tempArr = []
            console.log("pitInventoryDetails", pitInventoryDetails)
            pitInventoryDetails?.map((item, index) => {
                const qualityWorkLogEntity = []
                item.weight && qualityWorkLogEntity.push(
                    {
                        "qualityParameter": "Weight",
                        "actualQuantity": item?.weight,
                        "materialCode": details?.materialCode
                    },
                )
                item.moisture && qualityWorkLogEntity.push({
                    "qualityParameter": "AvgMoisture",
                    "actualQuantity": item?.moisture,
                    "materialCode": details?.materialCode
                })
                tempArr.push({
                    "bundleId": item?.bundleId,
                    "qualityWorkLogEntity": qualityWorkLogEntity,
                })
            })
            console.log("tempArr", tempArr)
            setBundleIdEntity(tempArr)
        }
    }, [pitInventoryDetails]);
    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "materialCode") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            setShowTable(false)
            setErrorMessage({ ...errorMessage, errmaterialCode: "" });
        }
        if (e.target.name === "inspectorName") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            let result_details = e.target?.value?.split("*")
            setDetails({ ...details, inspectorName: result_details[0], inspectorEmail: result_details[1], inspectorMobileNo: result_details[2] })
        }
        if (e.target.name === "surprise") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            setErrorMessage({ ...errorMessage, errSurprise: "" });
            (e.target.value === 'Yes') ? setDetails({ ...details, surprise: 'Yes', isSurpeiseCheck: true }) : setDetails({ ...details, surprise: 'No', isSurpeiseCheck: false })
        }
        if (e.target.name === "inspectDescription") {
            setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) })
            setErrorMessage({ ...errorMessage, errdescription: "" });
        }
        if (e.target.name === "inspectionFor") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            setShowTable(false)
            if (e.target.value === 'Plant') {
                setShowURNInput(false)
                setDetails({ ...details, selectedURN: 'Plant', inspectionFor: 'Plant' })
            }
            else {
                setShowURNInput(true)
                setDetails({ ...details, selectedURN: '', inspectionFor: e.target.value })
            }

            setErrorMessage({ ...errorMessage, errinspectionFor: "" });
        }
    }
    const handleDateChange = (e) => {
        setDateValue(e.format("YYYY-MM-DD"));
    }
    const handleMultiEquipment = (e) => {
        const { target: { value }, } = e;
        setMultiSelectEquipment(
            typeof value === 'string' ? value.split(',') : value,
        );
        setErrorMessage({ ...errorMessage, errequipmentused: "" });
    }
    const onSearch = (e) => {
        setSearch(true);
        if (!details.materialCode) {
            setErrorMessage({ ...errorMessage, errmaterialCode: "Select Material Code" });
        }
        else if (!details.inspectionFor) {
            setErrorMessage({ ...errorMessage, errinspectionFor: "Select Inspection" });
        }
        else if (!details.selectedURN) {
            setErrorMessage({ ...errorMessage, errSelectedUrn: "Select URN" });
        }
        else {
            // getpitinventorydetails(details.inspectionFor, details.materialCode, setPitInventoryDetails)
            getpitinventorydetails(details?.selectedURN, setPitInventoryDetails)

        }
    }
    const onClickChecked = (value) => {
        let filteredArray = bundleIdEntity?.filter(function (itm) {
            return value.indexOf(itm?.bundleId) > -1;
        });
        setSelectedLleIsData(filteredArray)
    }

    const onConfirmSubmit = () => {
        handleLogModalCloseSubmit();
        createWorkOrderReqst.push({
            "inspectionOrderId": '',
            "inspectDescription": details?.inspectDescription,
            "categoryOfInspection": pitInventoryDetails[0]?.stakeholderType,
            "requesterName": '',
            "inspectorName": details.inspectorName,
            "inspectorEmail": details.inspectorEmail,
            "inspectorContactNo": details.inspectorMobileNo,
            "materialCode": details.materialCode,
            "inspectionEquipmentUsed": multiselectEquipment?.map(i => i).join(', '),
            "status": 'Open',
            "measuredQuantity": '',
            "stakeholderUrn": details?.selectedURN,
            "dateOfInspection": datevalue ? datevalue : moment().format("YYYY-MM-DD"),
            "inspectionLocationType": details?.inspectionFor,
            "inspectionStorageLocation": details?.selectedURN,
            "lotNumber": '',
            "triggeringReason": 'Scheduled',
            "grievenceNumber": '',
            "surprise": details?.isSurpeiseCheck,
            "bundleIdEntity": selectedLleIsData
        })
        saveinspectiondetails(createWorkOrderReqst, setFinalInspectionSubmission, navigate);
    }

    const PitFinalSubmit = (e) => {
        setSubmit(true);
        if (!details.surprise) {
            setErrorMessage({ ...errorMessage, errSurprise: "Select Surprise" });
        }
        else if (multiselectEquipment?.length < 1) {
            setErrorMessage({ ...errorMessage, errequipmentused: "Select Equipment Details" });
        }
        else if (!details.inspectDescription) {
            setErrorMessage({ ...errorMessage, errdescription: "Add Inspection Description" });
        }
        else if (selectedLleIsData?.length < 1) {
            toast.error('Please Checked Minimum One Inspection Details')
        }
        else {
            handleLogModalOpenSubmit();
        }
    }
    const columns = [
        { field: 'categoryName', headerName: 'Inspection Location Type', width: 190 },
        { field: 'stakeholderType', headerName: 'Category Of Inspection', width: 190 },
        {
            field: 'urn', headerName: 'Stakeholder URN', width: 190,
            sortComparator: (a, b) => lastFiveDigitsComparator(a, b),
            renderCell: (params) => {
                return (
                    details?.selectedURN ? <Typography>{details?.selectedURN}</Typography> : <></>
                )
            }
        },
        { field: 'bundleId', headerName: 'Bundle ID', width: 200 },
        {
            field: 'triggeringReason', headerName: 'Triggering Reason', width: 150,
            renderCell: (params) => {
                return (
                    <Typography>Scheduled</Typography>
                )
            }
        },
        {
            field: 'qualityWorkLogEntity', headerName: 'Quality parameter', width: 200,
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.weight ? 'Weight' : ''}{params?.row?.moisture ? ', AvgMoisture' : ''}</Typography>
                )
            }
        }
    ]
    return (
        <>
            <Helmet>
                <title> Create New Inspection Work Order </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate(`../inspectionworkorder/addinspectionwork/`) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> Add Inspection Work Order
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%' }} error={search && !details.materialCode}>
                                    <InputLabel id="categoryinspection-label">Material Code</InputLabel>
                                    <Select
                                        label="Material Code"
                                        name='materialCode'
                                        required
                                        value={details?.materialCode || ''}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        {allmaterialcode?.Material_code?.map((materialval) =>
                                            <MenuItem key={materialval} value={materialval}>{materialval}</MenuItem>
                                        )}
                                    </Select>
                                    <FormHelperText>{errorMessage?.errmaterialCode}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl sx={{ width: '100%' }} error={search && !details.inspectionFor}>
                                    <InputLabel id="categoryinspection-label">Inspection For</InputLabel>
                                    <Select
                                        label="Inspection For"
                                        labelId="categoryinspection-label"
                                        id="category-inspection"
                                        name='inspectionFor'
                                        required
                                        value={details.inspectionFor || ''}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        {allinspectiondetails?.Inspection_for?.map((inspectionval) =>
                                            <MenuItem key={inspectionval} value={inspectionval}>{inspectionval}</MenuItem>

                                        )}
                                    </Select>
                                    <FormHelperText>{errorMessage?.errinspectionFor}</FormHelperText>
                                </FormControl>
                            </Grid>
                            {showURNInput &&
                                <Grid item xs={12} lg={3}>
                                    <FormControl sx={{ width: '100%' }} error={search && !details.selectedURN}>
                                        <InputLabel id="search-urn-label">Search By URN</InputLabel>
                                        <Select
                                            label="Search By URN"
                                            name='selectedURN'
                                            required
                                            value={details?.selectedURN || ''}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value=""><em>Select</em></MenuItem>
                                            {getUrnList?.urnList?.map((listallurn) =>
                                                <MenuItem key={listallurn?.urn} value={listallurn?.urn}>{listallurn?.urn}</MenuItem>
                                            )}
                                        </Select>
                                        <FormHelperText>{errorMessage?.errSelectedUrn}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item xs={12} lg={2} mt={1}>
                                <Button sx={{ minWidth: 120 }} variant="contained" startIcon={<SearchIcon />} onClick={(e) => onSearch(e)}>Search</Button>
                            </Grid>
                            {showtable && pitInventoryDetails?.length > 0 &&
                                <>
                                    <Grid item xs={12} lg={12} mt={2}>
                                        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
                                            <DataGrid
                                                rows={pitInventoryDetails}
                                                columns={columns}
                                                pageSize={5}
                                                rowsPerPageOptions={[5]}
                                                getRowId={(row) => row?.bundleId}
                                                rowHeight={80}
                                                checkboxSelection
                                                onSelectionModelChange={(e) => onClickChecked(e)}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%' }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Date of Inspection"
                                                    inputFormat="DD/MM/YYYY"
                                                    disablePast
                                                    value={datevalue}
                                                    onChange={(e) => { handleDateChange(e) }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ width: 750 }}
                                                /></LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%' }}>
                                            <InputLabel id="select-inspector-list-label">Inspector</InputLabel>
                                            <Select
                                                labelId="select-inspector-list-label"
                                                id="select-inspector"
                                                label="Inspector"
                                                name="inspectorName"
                                                onChange={(e) => handleChange(e)}>
                                                <MenuItem value=""><em>Select</em></MenuItem>
                                                {
                                                    inspectorDetails?.map((inspectorlist) =>
                                                        <MenuItem value={inspectorlist?.firstname + '*' + inspectorlist?.emailAddress + '*' + inspectorlist?.mobileNo}>{inspectorlist?.firstname}</MenuItem>
                                                    )}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl sx={{ width: '100%' }} error={submit && !details.surprise}>
                                            <InputLabel id="select-check-surprise-label">Surprise</InputLabel>
                                            <Select
                                                labelId="select-check-surprise-label"
                                                id="select-check-surprise-equipment"
                                                label="Surprise"
                                                name="surprise"
                                                onChange={(e) => handleChange(e)}>
                                                <MenuItem><em>Select</em></MenuItem>
                                                <MenuItem value="Yes">Yes</MenuItem>
                                                <MenuItem value="No">No</MenuItem>
                                            </Select>
                                            <FormHelperText>{errorMessage?.errSurprise}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4} mt={2}>
                                        <FormControl sx={{ width: '100%' }} error={submit && (multiselectEquipment?.length < 1)}>
                                            <InputLabel id="select-used-equipment-label">Equipment to be Used</InputLabel>
                                            <Select
                                                labelId="select-used-equipment-label"
                                                id="select-used-equipment"
                                                label="Equipment to be Used"
                                                name="equipmentdetails"
                                                multiple
                                                value={multiselectEquipment}
                                                onChange={handleMultiEquipment}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value} />
                                                        ))}
                                                    </Box>
                                                )}
                                                MenuProps={MenuProps}
                                                sx={{ minWidth: 150 }}>
                                                <MenuItem>
                                                    <em>Select</em>
                                                </MenuItem>
                                                {
                                                    allequipmentdetails?.Inspection_equipment?.map((equipdetails) =>
                                                        <MenuItem value={equipdetails}>{equipdetails}</MenuItem>
                                                    )}
                                            </Select>
                                            <FormHelperText>{errorMessage?.errequipmentused}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={9} mt={2}>
                                        <FormControl sx={{ width: '100%' }} error={submit && !details.inspectDescription}>
                                            <TextField fullWidth
                                                autoComplete="off"
                                                label="Description"
                                                inputProps={{
                                                    maxLength: openTextFieldMaxLength
                                                }}
                                                multiline
                                                color="info"
                                                rows={5}
                                                value={details.inspectDescription || ''}
                                                name='inspectDescription'
                                                onChange={(e) => handleChange(e)}
                                            />
                                            <FormHelperText>{errorMessage?.errdescription}</FormHelperText>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} lg={12} mt={2}>
                                        <Box display='flex' alignItems="center" justifyContent="center">
                                            <Button endIcon={<SubmitIcon />} sx={{ minWidth: 120 }} variant="contained" onClick={(e) => PitFinalSubmit(e)}>Submit</Button>
                                        </Box>
                                    </Grid>
                                </>}
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
        </>
    )
}

export default CreateNewInspectionOrder